import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import useAddressPickerModal from '@features/address-picker/hooks/useAddressPickerModal'

import Button from '@shared/ui/button'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
} from '@shared/ui/form'
import Input from '@shared/ui/input'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function PickupForm () {
  const { control } = useFormContext()
  const { t: o } = useTranslation('order')
  const { t: c } = useTranslation('common')
  const { openAddressPickerModal } = useAddressPickerModal()

  return (
    <Wrapper className={styles.root__wrapper}>
      <h3 className={styles.root__title}>{c('pickup')}</h3>
      <div className={styles.root}>
        <div className={styles.form}>
          <FormField
            control={control}
            name="address"
            render={({ field }) => (
              <FormItem className={styles.form__item}>
                <FormControl>
                  <Input
                    disabled
                    theme="grey"
                    {...field}
                    placeholder={o('form.address.placeholder')}
                  />
                </FormControl>
                <Button
                  onClick={() => {
                    openAddressPickerModal()
                  }}
                  theme="secondary"
                >
                  {c('change')}
                </Button>
                <FormDescription>
                  <span>{o('form.address.description')}</span>
                </FormDescription>
              </FormItem>
            )}
          />
        </div>
      </div>
    </Wrapper>
  )
}
